import { DishAllergen, DishDisclaimers } from "api-types";

import React from "react";

import { Stack, Typography } from "@mui/material";

import { AllergenChipOutlined } from "../../Chip/Chip";
import { useFilterMenu } from "../filters";

interface DishMayContainProps {
  hasFilteredAllergensOrIngredient: boolean;
  allergenDisclaimers: DishDisclaimers[];
  hasMatchingAllergens: boolean;
  matchedMayContainAllergens: DishAllergen[];
}

export const DishMayContain = ({
  allergenDisclaimers,
  hasFilteredAllergensOrIngredient,
  hasMatchingAllergens,
  matchedMayContainAllergens,
}: DishMayContainProps) => {
  const filterMenu = useFilterMenu();
  const mayContainDisplayed = filterMenu.showMayContainAllergens
    ? matchedMayContainAllergens.length
    : 0;
  return (
    <Stack gap={1}>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {filterMenu.showAllergenDetails && (
          <>
            <Typography variant="labelXSMedium">May contain:</Typography>
            {filterMenu.showMayContainAllergens &&
              !!matchedMayContainAllergens.length && (
                <AllergenChipOutlined
                  mayContain
                  allergenName={matchedMayContainAllergens[0].allergenName}
                />
              )}
            {hasFilteredAllergensOrIngredient &&
              mayContainDisplayed === 0 &&
              !!allergenDisclaimers.length && (
                <AllergenChipOutlined
                  mayContain
                  allergenName={`Possible allergen(s): ${allergenDisclaimers[0].title}`}
                />
              )}
          </>
        )}
        {!hasMatchingAllergens && !filterMenu.showAllergenDetails && (
          <AllergenChipOutlined
            mayContain
            allergenName="May not be suitable."
            link="Why?"
          />
        )}
        {filterMenu.showAllergenDetails &&
          matchedMayContainAllergens.length > 1 && (
            <AllergenChipOutlined
              mayContain
              allergenName={`+${matchedMayContainAllergens.length - 1}`}
            />
          )}
        {!filterMenu.showAllergenDetails &&
          !!(allergenDisclaimers.length - 1) &&
          allergenDisclaimers.length > 0 && (
            <AllergenChipOutlined
              mayContain
              allergenName={`+${
                mayContainDisplayed +
                (allergenDisclaimers.length > 1
                  ? allergenDisclaimers.length - 1
                  : 0)
              }`}
            />
          )}
      </Stack>
    </Stack>
  );
};
